import { useEffect, useState } from 'react';
export function usePropDrivenState(propState, onChange) {
    const [value, setValue] = useState(propState);
    useEffect(() => {
        setValue(propState);
        onChange?.();
    }, [propState, onChange]);
    return [value, setValue];
}
